import { computed, Injectable, signal } from '@angular/core';
import { UtilitiesRxjs } from 'src/app/services/utilities.rxjs';
import { IContextData } from './context-data.models';

@Injectable({
    providedIn: 'root'
})
export class ContextDataService {


    context = signal<IContextData>(null);
    showPanel = signal<boolean>(false);
    showing = computed(() => {
        const context = this.context();
        if (this.showPanel()) {
            return context?.name;
        }

        return false;
    });

    dataRetrievalFn: (contextName: string) => Promise<any>;
    data = signal<any>(null);
    loadingData = signal<boolean>(false);
    private readonly listeners: ((data: any) => void)[] = [];
    private readonly showingListeners: ((data: any) => void)[] = [];

    constructor() { }


    setContext<T>(context: string | IContextData, dataRetrievalFn: (name: string) => Promise<T>): void {
        if (typeof context === 'string') {
            context = { name: context, displayName: context, icon: 'fal fa-puzzle-piece' } as IContextData;
        }

        // Implementation to set the context
        if (context && context.name !== this.context()?.name) {
            this.context.set(context);
            this.dataRetrievalFn = dataRetrievalFn;
            this.refreshData(context.name);
        }

        this.showPanel.set(true);
    }

    registerDataListener(callBackFn: (data: any) => void) {
        this.listeners.push(callBackFn);
    }
    registerShowingListener(callBackFn: (showing: string) => void) {
        this.showingListeners.push(callBackFn);
    }
    async refreshData(name: string) {
        if (this.showPanel && name === this.context()?.name) {
            try {
                this.loadingData.set(true);
                const data = await UtilitiesRxjs.handleData(this.dataRetrievalFn(name));
                this.data.set(data);
                this.listeners.forEach(listener => {
                    listener(data);
                });
            } finally {
                this.loadingData.set(false);
            }
        }
    }
}
